import { Link } from "react-router-dom";
import HoverUnderLine from "./HoverUnderLine";
import { Rocket, Contact, Flex } from "../assets";

const Logo = ({ type }) => {
  return (
    <div className="">
      <HoverUnderLine>
        <Link
          to="/"
          className={`text-2xl font-semibold dark:text-white ${
            type && "text-white  text-4xl"
          }`}
        >
          <img
            src={Flex}
            loading="lazy"
            alt="features"
            className="w-[40px] h-[40px] object-contain"
          />
          Flex
        </Link>
      </HoverUnderLine>
    </div>
  );
};

export default Logo;
